import { FC } from 'react'

import lsd from 'assets/lsd.png'

import { formatCountLSD } from 'utils/formatCountLSD'

import s from './s.module.scss'

type Props = {
  count: string
}

const CountLSD: FC<Props> = ({ count }) => {
  return (
    <div className={s.lsd}>
      <img alt="LSD" height={32} src={lsd} width={32} />

      <span>{formatCountLSD(count)}&nbsp;LSD</span>
    </div>
  )
}

export default CountLSD
